import { makeAutoObservable, runInAction } from "mobx";
import CreateRmaService, { IPortalDynamicShippingOptionDto } from "../../../services/api/create-rma-service";
import { rootContainer, TYPE } from "../../../services/container/root";
import RmaRequestStore, { ICreateRmaDto } from "./rma-request-store";

export default class CreateRmaDynamicShippingOptionsStore {
	private _shippingOptions: IPortalDynamicShippingOptionDto[] = [];
	private _selectedOption: IPortalDynamicShippingOptionDto | null = null;
	private _requestStore: RmaRequestStore;
	private _isDynamicShippingOptionsSupported: boolean = false;
	private _isLoading: boolean = false;

	constructor(requestStore: RmaRequestStore) {
		makeAutoObservable(this, {}, { autoBind: true });
		this._requestStore = requestStore;
	}

	public get shippingOptions(): IPortalDynamicShippingOptionDto[] {
		return this._shippingOptions;
	}

	public get selectedOption(): IPortalDynamicShippingOptionDto | null {
		return this._selectedOption;
	}

	public get shouldSelectShippingOption(): boolean {
		return this._isDynamicShippingOptionsSupported && this._selectedOption === null;
	}

	public get isLoading(): boolean {
		return this._isLoading;
	}

	public get isDynamicShippingOptionsSupported(): boolean {
		return this._isDynamicShippingOptionsSupported;
	}

	private get _createRmaService(): CreateRmaService { return rootContainer.get<CreateRmaService>(TYPE.CreateRmaService); }

	public async fetchDynamicShippingOptions(): Promise<void> {
		this._isLoading = true;
		this._reset();
		const request = this._requestStore.requestModel();
		const response = await this._createRmaService.getDynamicShippingOptions(request);
		runInAction(() => {
			this._shippingOptions = response.shipping_options;
			this._isDynamicShippingOptionsSupported = response.is_dynamic_shipping_options_supported;
			this._isLoading = false;
		});
	}

	public setSelectedOption(option: IPortalDynamicShippingOptionDto): void {
		this._selectedOption = option;
	}

	private _reset(): void {
		runInAction(() => {
			this._shippingOptions = [];
			this._selectedOption = null;
		});
	}

	public __destroy(): void {
		this._reset();
	}
}
